import React from "react";
import { withStyles } from "@material-ui/core";
import { withSnackbar } from "notistack";
import DataGrid from '@dataGrid';
import GridConfig from "./gridConfig";
import styles from "../../../styles";
import { compose } from "recompose";
import DriverPreferencesGridHeader from "./gridHeader";
import { isEqual } from "lodash/lang";

class DriverPreferences extends React.PureComponent {
  constructor(props) {
    super(props);
    this.gridConfig = new GridConfig();
    this.state = {
      quickFilterText: "",
    };
  }

  componentDidUpdate(prevProps) {
    if (
      !isEqual(
        this.props.selectedDriverPreferences,
        prevProps.selectedDriverPreferences
      )
    ) {
      this.updateSelection();
    }
  }

  onGridReady = ({ api }) => {
    this.gridApi = api;
  };

  updateQuickFilterText = (value) => {
    this.setState({
      quickFilterText: value,
    });
  };

  onSelectionChanged = () => {
    if (this.gridApi) {
      const selectedDriverPreferences = this.gridApi
        .getSelectedRows()
        .map((drivers) => drivers);
      this.props.selectDriverPreferencesOnGrid(selectedDriverPreferences);
    }
  };

  updateSelection = () => {
    if (this.props.selectedDriverPreferences && this.gridApi) {
      const selectedDriverPreference = this.props.selectedDriverPreferences.map(
        (driver) => driver.startTime
      );
      this.gridApi.forEachNode((node) => {
        if (selectedDriverPreference.includes(node.data.startTime)) {
          this.gridApi.ensureIndexVisible(node.rowIndex);
          node.setSelected(true);
        }else{
          node.setSelected(false);
        }
      });
    }
  };

  render() {
    const {
      classes,
      driverData,
      isDriverPreferenceFromOpen,
      selectedDriverPreferences,
      onDeleteDriverPreference,
      onDriverPreferenceFormOpen,
      errorMessage,
      enableUpdateDriverPreferences,
    } = this.props;
    return (
      <div
        className={`${classes.gridContainer} ${classes.parameterGridContainer}`}
      >
        <DriverPreferencesGridHeader
          onDriverPreferenceFormOpen={onDriverPreferenceFormOpen}
          selectedDriverPreferences={selectedDriverPreferences}
          isDriverPreferenceFromOpen={isDriverPreferenceFromOpen}
          updateQuickFilterText={this.updateQuickFilterText}
          onDeleteDriverPreference={onDeleteDriverPreference}
          enableUpdateDriverPreferences={enableUpdateDriverPreferences}
          gridApi={this.gridApi}
        />
        <div className={`${classes.dataGrid} ${classes.parameterGrid}`}>
          <DataGrid
            defaultColDef={this.gridConfig.config.defaultColDef}
            columnDefs={this.gridConfig.config.columns}
            config={this.gridConfig.config}
            rowData={driverData}
            onGridReady={this.onGridReady}
            onCellValueChanged={this.onCellValueChanged}
            showErrorMessage={errorMessage}
            rowSelection={this.gridConfig.config.rowSelection}
            suppressRowClickSelection={isDriverPreferenceFromOpen}
            quickFilterText={this.state.quickFilterText}
            onSelectionChanged={this.onSelectionChanged}
            onRowDataUpdated={this.updateSelection}
          />
        </div>
      </div>
    );
  }
}

export default compose(withStyles(styles), withSnackbar)(DriverPreferences);
